module.exports = __webpack_public_path__ + "A9opyD_72i.png";


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/CommonCell/components/GoodItem/asset/grab.png
// module id = 742
// module chunks = 438